import { Pipe, PipeTransform } from '@angular/core';
import { camelCase, startCase } from 'lodash';

@Pipe({
  name: 'mcStartCase'
})
export class StartCasePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    return startCase(camelCase(value));
  }
}
